import { indexData } from '@/mocks/home-data';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            专题合集
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          按主题浏览，快速定位你感兴趣的内容领域
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#updates"
              className="group bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline flex flex-col gap-2"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-md bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-200`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs text-primary-400 font-medium mt-auto">
                {item.count} 篇内容
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}